import parsePhoneNumberFromString from 'libphonenumber-js';

export default function isPhoneNumber(input: string): boolean {
  const phoneNum = parsePhoneNumberFromString(input);
  const result = phoneNum?.isValid();
  return !!result;
}
